import React, { SVGProps } from 'react'

export const SkeletonCircle = ({ ...props }: SVGProps<SVGCircleElement>) => {
  return <circle cx={16} cy={16} r={16} {...props} />
}
